import React, { useState, useEffect, useMemo } from "react";
import CardAddButton from "../../assets/icons/CardAddButton.svg";
import upArrow from "../../assets/icons/upArrow.png";
import { useHistory, useLocation, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FetchPOByProject } from "../../redux/actions/action";

import moment from "moment";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { fetchScreenTranslations } from "../../utils/helpers/translations";

const AddStock = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const projectId = window.localStorage.getItem("projectid");
  const roleid = window.localStorage.getItem("roleid");
  const fetchPOByProjectResponse = useSelector(
    (state) => state.user.fetchPOByProjectResponse,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";

  const [stockList, setStockList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [pagesArray, setPagesArray] = useState([]);
  const [sorting, setSorting] = useState("");

  useEffect(() => {
    // if (location?.pathname === "/updateProject") {
    if (location?.pathname.startsWith("/project/")) {
      dispatch(
        FetchPOByProject(projectId, "Purchasing", pageNumber, itemsPerPage),
      );
    }
  }, [location, pageNumber]);

  useEffect(() => {
    if (fetchPOByProjectResponse?.status === true) {
      setStockList(fetchPOByProjectResponse?.data);
      let pages = Math.ceil(
        fetchPOByProjectResponse?.totalCount / itemsPerPage,
      );
      setTotalPages(pages);
      setTotalItems(fetchPOByProjectResponse?.totalCount);
      let array = [];
      for (let i = 1; i <= pages; i++) {
        array.push(i);
      }
      setPagesArray([...array]);
    }
  }, [fetchPOByProjectResponse]);

  useEffect(() => {
    fetchScreenTranslations("Add-Project").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  return (
    <div className="quotes-main-container">
      <div
        className="quotes-div-1 fr"
        style={{
          flexWrap: "wrap",
        }}
      >
        <section
          className="fr"
          style={{ gap: "7px", alignItems: "center", cursor: "pointer" }}
          onClick={() =>
            history.push("/add-purchasing-order", "/updateProject")
          }
        >
          {roleid !== process.env.REACT_APP_IS_VIEWER && (
            <>
              <img src={CardAddButton} className="addDocImg" alt="Add Icon" />
              <p className="addDocText">
                {/* Add Purchase Order */}
                {t("Add Purchase Order")}
              </p>
            </>
          )}
        </section>
        <section
          className="fr quotes-div-sec-2 addstock-page-length  addstock-page-in-tablet ms-auto"
          style={{ gap: "7px" }}
        >
          <p>
            {pageNumber === 1 ? 1 : itemsPerPage * (pageNumber - 1) + 1}-
            {itemsPerPage * pageNumber > totalItems
              ? totalItems
              : itemsPerPage * pageNumber}
          </p>
          <p>of</p>
          <p>{totalItems}</p>
          <p
            className="aro-lr"
            onClick={() => {
              if (pageNumber === 1) return;
              setPageNumber((p) => p - 1);
            }}
          >
            {"<"}
          </p>
          <p className="quote-current-page">{pageNumber}</p>
          <p
            className="aro-lr"
            onClick={() => {
              if (pageNumber >= totalPages) return;
              setPageNumber((p) => p + 1);
            }}
          >
            {">"}
          </p>
        </section>
      </div>
      <div className="invoice-main-grid">
        <p className="task-grid-element">
          {/* Date */}
          {t("Date")}
        </p>
        <p className="task-grid-element">
          {/* Prchase <br /> Order Id */}
          {t("Purchase Order ID").slice(0, 8)}
          <br />
          {t("Purchase Order ID").slice(8)}
        </p>
        <p className="task-grid-element">
          {/* Supplier */}
          {t("Supplier")}
        </p>
        <p
          className="task-grid-element hide-on-mobile"
          style={{ textAlign: "end" }}
        >
          {/* Total <br /> excl. Btw */}
          {t("Total excl. Btw").slice(0, 5)}
          <br />
          {t("Total excl. Btw").slice(5)}
        </p>
        <p
          className="task-grid-element hide-on-mobile"
          style={{ textAlign: "end" }}
        >
          {/* Total <br /> incl. Btw */}
          {t("Total incl. Btw").slice(0, 5)}
          <br />
          {t("Total incl. Btw").slice(5)}
        </p>
        <p
          className="task-grid-element hide-on-mobile"
          style={{ textAlign: "end" }}
        >
          <span>
            <img
              src={upArrow}
              alt="Up Arrow"
              width={18}
              className="pointer"
              style={{ transform: `rotate(${sorting === "asc" ? 0 : 180}deg)` }}
              onClick={() => {
                setSorting(sorting === "asc" ? "desc" : "asc");
              }}
            />
          </span>{" "}
          {/* Status */}
          {t("Status")}
        </p>
      </div>
      <div className="add-stock-line"></div>
      {stockList
        ?.sort((a, b) => {
          if (sorting === "asc") {
            if (a.statusname === "Awaiting Approval") return -1;
            if (b.statusname === "Awaiting Approval") return 1;

            if (a.statusname === "Awaiting Delivery") return 1;
            if (b.statusname === "Awaiting Delivery") return -1;
          }

          if (sorting === "desc") {
            if (a.statusname === "Awaiting Delivery") return -1;
            if (b.statusname === "Awaiting Delivery") return 1;

            if (a.statusname === "Awaiting Approval") return 1;
            if (b.statusname === "Awaiting Approval") return -1;
          }

          return 0;
        })
        ?.map((stock, index) => {
          return (
            <Link // Link Below code not in use.
              to={{
                pathname: `/view-purchasing-order/${stock.ordercode}`,
                state: {
                  supplierid: stock.supplierid,
                  projectname: stock.projectname,
                  suppliername: stock.suppliername,
                },
              }}
              className="redirect-link"
            >
              <div
                onClick={() => {
                  window.localStorage.setItem("orderid", stock.orderid);
                }}
                className="invoice-main-grid addStockListBorder"
                key={index}
                style={{
                  opacity: stock?.statusname === "Delivered" ? "1" : "60%",
                }}
              >
                <p className="task-grid-element-2">
                  {moment(stock?.createdat).format("DD.MM.YYYY")}
                </p>
                <p className="task-grid-element-2">
                  <Link // Link Below code not in use.
                    to={{
                      pathname: `/view-purchasing-order/${stock.ordercode}`,
                      state: {
                        supplierid: stock.supplierid,
                        projectname: stock.projectname,
                        suppliername: stock.suppliername,
                      },
                    }}
                    className="redirect-link"
                  >
                    {stock.ordercode}
                  </Link>
                </p>
                <p className="task-grid-element-2">{stock?.suppliername}</p>
                <p
                  className="task-grid-element-2 hide-on-mobile"
                  style={{ textAlign: "end" }}
                >
                  {europeanFormatWithSymbol(parseInt(stock?.totalExclusiveBtw))}
                </p>
                <p
                  className="task-grid-element-2 hide-on-mobile"
                  style={{ textAlign: "end" }}
                >
                  {europeanFormatWithSymbol(parseInt(stock?.totalInclusiveBtw))}
                </p>
                <p
                  className="task-grid-element-2 hide-on-mobile"
                  style={{ textAlign: "end" }}
                >
                  {stock?.statusname}
                </p>
              </div>
            </Link>
          );
        })}
      {stockList.length === 0 && (
        <span className="noDataDisplay">
          {/* No data to display! */}
          {t("No data to display!\n")}
        </span>
      )}
    </div>
  );
};

export default AddStock;
